import HorsePage from './HorsePage';

export default HorsePage;
